import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { shallowEqual, useSelector } from 'react-redux';

import { cancel } from '../../../../airtable/generic';
import { fetchRecords } from '../../../../airtable/grading';
import { gradingFields } from '../../../../airtable/metadata/grading';
import { createColumn } from '../../../components/dynamic-table';
import { ExpandableTable } from '../../../components/expandable-table';

const ordersColumns = [
  createColumn(gradingFields.ORDER_NUMBER, { type: 'numeric', emptyValue: 'No order number' }),
  createColumn(gradingFields.ORDER_STATUS, { type: 'numeric', emptyValue: '-' }),
];

const cardsColumns = [
  createColumn(gradingFields.YEAR, { type: 'numeric' }),
  createColumn(gradingFields.CARD_NAME, { type: 'string', title: 'Player' }),
  createColumn(gradingFields.SET, { type: 'string' }),
  createColumn(gradingFields.CARD_NUMBER, { type: 'string' }),
];

export function GradingDestinationTable(props) {
  const { base } = props;

  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const promise = fetchRecords(base, user)
      .then(records => {
        // adds an order field to make it easier to group and filter rows
        const path = ['fields', gradingFields.ORDER_NUMBER, 0];
        const rowsWithFallback = _.map(records, row => {
          return { ...row, order: _.get(row, path, Number.MAX_SAFE_INTEGER) };
        });

        setRows(rowsWithFallback);
      });

    return () => cancel(promise);
  }, [base, user]);

  function renderOrdersTable() {
    const grouped = group(rows, ['order']);
    const orders = _.map(grouped, _.first);
    const ordered = _.orderBy(orders, ['order'], ['desc']);

    return (
      <ExpandableTable columns={ordersColumns} rows={ordered}>
        {row => renderCardsTable(row)}
      </ExpandableTable>
    );
  }

  function renderCardsTable(orderRow) {
    const cards = _.filter(rows, {
      order: orderRow.order,
    });

    const columns = [
      ...cardsColumns,
      createColumn(gradingFields.GRADE, { title: `${base} Grade`, type: 'numeric' }),
    ];

    return (
      <ExpandableTable
        columns={columns}
        rows={cards}
      />
    );
  }

  return renderOrdersTable();
}

function group(list, names = []) {
  if (!names.length) {
    return list;
  }
  const [first, ...rest] = names;
  const grouped = _.groupBy(list, first);
  const groups = _.values(grouped);

  return _.map(groups, context => group(context, rest));
}
